module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/eo-outside-sg/tab-e0f447ebedea2a4b9d472497bacf0071.png";